/** @module Specification/CareAndComposition/CareSymbolsPerLanguageController */
define([
    "dojo/_base/declare",
    "csi/store/Nodes",
    "csi/table/Widget",
    "csi/xml/Query",
], function(declare,Nodes,Table,Query) {

    return declare(Table, {

        /**
         * Send request to Java to get Languages for the active sales product spec or all languages for this style's sales product specs
         * @param {Deferred[]} dfds
         */
        onViewStart: function(dfds) {

            var activeSalesRegion = this.viewParent.activeProductSalesRegion;
            var urlRoot = this.urlRoot;

            var store = new Nodes({
                cachingStore: this.cacheView,
                requestModule: "Specification",
                requestOperation: "CareAndCompositionGetLanguages",
                requestParameters: {
                    "URL": urlRoot,
                    "ActiveProductSalesRegion": activeSalesRegion
                },
                sortQuery: new Query().SortByAttr("SortOrder"),
            });
            this.set("store", store);

            this.inherited(arguments);
        }

    });
});